import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  originalCollections: null,
  collections: null,
  collectionsByCompany: null,
  status: 'idle',
  error: null,
  addCollectionStatus: 'idle',
  addCollectionError: null,
  editCollectionStatus: 'idle',
  editCollectionError: null,
  collectionDetails: null,
  selectedCollectionID: null,
  // drive operations
  collectionDrives: null,
  getCollectionDrivesStatus: 'idle',
  getCollectionDrivesError: null,
  addDriveStatus: 'idle',
  addDriveError: null,
  removeDriveStatus: 'idle',
  removeDriveError: null,
  datasetID: null,
  boundaries: {
    north: null,
    south: null,
    east: null,
    west: null,
  },
};

const collectionSlice = createSlice({
  name: 'collection',
  initialState,
  reducers: {
    getCollectionsStart: (state) => {
      state.status = 'loading';
      state.collections = null;
      state.error = null;
    },
    getCollectionsSuccess: (state, action) => {
      state.status = 'success';
      state.collections = action.payload.data;
      state.originalCollections = action.payload.data;
      state.error = null;
    },
    getCollectionsFailure: (state, action) => {
      state.status = 'fail';
      state.error = action.payload.message;
    },
    getCollectionsByCompany: (state, action) => {
      state.collectionsByCompany = action.payload.data;
    },
    addCollectionStart: (state) => {
      state.addCollectionStatus = 'loading';
      state.editCollectionStatus = 'loading';
      state.addCollectionError = null;
      state.editCollectionError = null;
    },
    addCollectionSuccess: (state) => {
      state.addCollectionStatus = 'success';
      state.addCollectionError = null;
    },
    addCollectionFailure: (state, action) => {
      state.addCollectionStatus = 'fail';
      state.addCollectionError = action.payload.message;
    },
    editCollectionStart: (state) => {
      state.addCollectionStatus = 'loading';
      state.editCollectionStatus = 'loading';
      state.addCollectionError = null;
      state.editCollectionError = null;
    },
    editCollectionSuccess: (state) => {
      state.editCollectionStatus = 'success';
      state.editCollectionError = null;
    },
    editCollectionFailure: (state, action) => {
      state.editCollectionStatus = 'fail';
      state.editCollectionError = action.payload.message;
    },
    fetchCollectionDetailsStart: (state) => {
      state.collectionDetails = null;
    },
    fetchCollectionDetailsSuccess: (state, action) => {
      state.collectionDetails = action.payload.data;
    },
    setSelectedCollectionID: (state, action) => {
      state.selectedCollectionID = action.payload;
    },
    resetCollectionDetails: (state) => {
      state.collectionDetails = null;
    },
    // drive reducers
    getCollectionDrivesStart: (state) => {
      state.getCollectionDrivesStatus = 'loading';
      state.collectionDrives = null;
      state.getCollectionDrivesError = null;
    },
    getCollectionDrivesSuccess: (state, action) => {
      state.getCollectionDrivesStatus = 'success';
      state.collectionDrives = action.payload.data;
      state.getCollectionDrivesError = null;
    },
    getCollectionDrivesFailure: (state, action) => {
      state.getCollectionDrivesStatus = 'fail';
      state.getCollectionDrivesError = action.payload.message;
    },
    addDriveStart: (state) => {
      state.addDriveStatus = 'loading';
      state.addDriveError = null;
    },
    addDriveSuccess: (state) => {
      state.addDriveStatus = 'success';
      state.addDriveError = null;
    },
    addDriveFailure: (state, action) => {
      state.addDriveStatus = 'fail';
      state.addDriveError = action.payload.message;
    },
    removeDriveStart: (state) => {
      state.removeDriveStatus = 'loading';
      state.removeDriveError = null;
    },
    removeDriveSuccess: (state) => {
      state.removeDriveStatus = 'success';
      state.removeDriveError = null;
    },
    removeDriveFailure: (state, action) => {
      state.removeDriveStatus = 'fail';
      state.removeDriveError = action.payload.message;
    },
    resetSnackbar: (state) => {
      state.addCollectionStatus = 'idle';
      state.editCollectionStatus = 'idle';
      state.addCollectionError = null;
      state.editCollectionError = null;
    },
    setFilteredCollectionList: (state, action) => {
      state.collections = action.payload;
    },
    setDatasetID: (state, action) => {
      state.datasetID = action.payload.datasetID;
      state.boundaries = {
        north: action.payload.datasetRecord.boundsNorth,
        south: action.payload.datasetRecord.boundsSouth,
        east: action.payload.datasetRecord.boundsEast,
        west: action.payload.datasetRecord.boundsWest,
      };
    },
    resetDatasetID: (state) => {
      state.datasetID = null;
      state.boundaries = {
        north: null,
        south: null,
        east: null,
        west: null,
      };
    },
  },
});

export const {
  getCollectionsStart,
  getCollectionsSuccess,
  getCollectionsFailure,
  getCollectionsByCompany,
  addCollectionStart,
  addCollectionSuccess,
  addCollectionFailure,
  editCollectionStart,
  editCollectionSuccess,
  editCollectionFailure,
  fetchCollectionDetailsStart,
  fetchCollectionDetailsSuccess,
  setSelectedCollectionID,
  resetCollectionDetails,
  // drive actions
  getCollectionDrivesStart,
  getCollectionDrivesSuccess,
  getCollectionDrivesFailure,
  addDriveStart,
  addDriveSuccess,
  addDriveFailure,
  removeDriveStart,
  removeDriveSuccess,
  removeDriveFailure,
  resetSnackbar,
  setFilteredCollectionList,
  setDatasetID,
  resetDatasetID,
} = collectionSlice.actions;

export default collectionSlice.reducer;
